/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fertilizer_SupplierInputs */

const vi_fertilizer_supplier = /** @type {(inputs: Fertilizer_SupplierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn vị cung cấp`)
};

/**

* @param {Fertilizer_SupplierInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fertilizer_supplier = /** @type {((inputs?: Fertilizer_SupplierInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fertilizer_SupplierInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fertilizer_supplier(inputs)
});